
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'

import {get,post} from '../api'

export default {
components: {
TransferDom,
Popup,
Tabbar,
TabbarItem,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
XImg,
Scroller,
ViewBox,
Cell,
Toast,
CellFormPreview

},
mounted () {
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
this.height = window.innerHeight - 46 -70;
post('/attachinfo/query/business', {RelatedGuid:this.GLOBAL.currentUser.BusinessGuid}).then(response => {

if(response.code==1){
response.data.forEach(element => {
this.imglist.push(process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/").replace("\\\\","/"));
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
methods: {
success (src, ele) {
console.log('success load', src)
const span = ele.parentNode.querySelector('span')
ele.parentNode.removeChild(span)
},
error (src, ele, msg) {
console.log('error load', msg, src)
const span = ele.parentNode.querySelector('span')
span.innerText = '图片加载失败...'
ele.parentNode.removeChild(span)
},
onScroll (pos) {
this.scrollTop = pos.top
},
addInfos(){
this.fileList.splice(0, this.fileList.length);
this.selectFiles='未选择资质图片';
this.showUpload=true;
},
UploadFile(){
if(this.fileList.length==0){
this.showWarn=true;
this.WarnInfo="未选择需要上传的资质图片";
return;
}
post('/file/upload', this.fileformData).then(response => {

if(response.code==1){
response.data.forEach(element => {
element.RelatedGuid=this.GLOBAL.currentUser.BusinessGuid;
this.imglist.push(process.env.BASE_URL.replace("api/", "")+element.Path);
});
post('/attachinfo/add/batch/business', response.data).then(response1 => {

if(response1.code==1){
this.showSuccess=true;
this.showUpload=false;
}
else if(response1.code==0){
this.showError=true;
}
else if(response1.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error1 => {
console.log(error1);
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
change(e) {
if (e.target.files.length > 0) {
this.getUrl(e.target.files); 
}
},
getUrl(file) {
console.log("getUrl", file)
this.selectFiles="共选择"+file.length+"个图片";

let _this = this;
this.fileformData = new FormData();

for (let i = 0; i < file.length; i++) {
this.fileformData.append("file", file[i]);
this.fileList.push(file[i].name);
}
}
},

data () {
return {
imglist: [],
scrollTop: 0,
height: 0,
showUpload:false,
fileList:[],
selectFiles:'未选择资质图片',
fileformData:[],
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'资质文件上传成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
}
}
}



// WEBPACK FOOTER //
// ./src/components/BusinessModules/CredentialDetail.vue